import { Routes } from "@angular/router";

export const SaleRoutes: Routes = [
	{
		path: "",
		loadComponent: () =>
			import("@/app/domains/erp/sales/pages/branch-sales/branch-sales.page").then(
				(m) => m.BranchSalesPage
			),
	},
	{
		path: "sale-view",
		loadComponent: () =>
			import("@/app/domains/erp/sales/pages/sale-view/sale-view.page").then((m) => m.SaleViewPage),
	},
	{
		path: "sale-view-edit",
		loadComponent: () =>
			import("@/app/domains/erp/sales/pages/sale-view-edit/sale-view-edit.page").then(
				(m) => m.SaleViewEditPage
			),
	},
	{
		path: "**",
		redirectTo: "",
		pathMatch: "full",
	},
];
